<div class="container">
  <div app-sidebar class="sidebar"></div>
  <div app-content class="main-section">
    <router-outlet></router-outlet>
  </div>
</div>
